// What the chat eval's runner (web-app/chat-eval/) reads off the page while it
// drives the chat box: whether a turn is still running, what the Allow card
// asks, and where the page is (the page context the chat itself sends).
// The runner types and clicks like a person; this only tells it when to look.
// Only on a dev server in isolated-emulator mode — the only place the eval
// runs (`CHAT_EVAL=1 npm run serve:dev:emulators`) — so a deployed build never
// sets it.
import { getPageContext } from '../sessionLink/pageContextStore';

/** On a dev server started with `npm run start:dev:emulators`. */
export const chatEvalProbeOn = (env = process.env) =>
  env.NODE_ENV === 'development' && env.REACT_APP_USE_EMULATORS === 'true';

/**
 * Put the chat turn's state on `window.__CHAT_EVAL__`. ChatProvider calls it
 * whenever the turn or its Allow card changes.
 * @param {{ turnRunning: boolean, pendingConfirm: { call } | null }} turn
 */
export function publishChatEvalProbe(
  { turnRunning, pendingConfirm },
  env = process.env
) {
  if (!chatEvalProbeOn(env)) return;
  const call = pendingConfirm?.call;
  window.__CHAT_EVAL__ = {
    turnRunning,
    pendingConfirm: call ? { name: call.name, input: call.input } : null,
    pageContext: () => getPageContext(),
  };
}
